import { SVGProps, Ref, forwardRef } from 'react';

export const CheckmarkOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21 7.273 9.273 19 3 12.727l1.273-1.273 5 5L19.727 6z"
                fill="currentColor"
            />
        </g>
    </svg>
));
CheckmarkOutlinedSize24Glyph.displayName = 'CheckmarkOutlinedSize24Glyph';
